import ManageAdvanceAccountScreen from 'features/advance/screens/manageAdvanceAccount/ManageAccount/ManageAdvanceAccountScreen';
import React from 'react';

export default function ManageAdvanceAccountPage() {
  return <ManageAdvanceAccountScreen />;
}
